export const checkTlGoalDesc = (tlGoalDesc:string,errors:string[]) => {
    if (tlGoalDesc.trim().length < 10) {
        errors.push('Tl goal description must be atleast 10 characters');
    } else if (tlGoalDesc.trim().length > 200) {
        errors.push('TL Goal description must be less than 200 characters');
    }
};
export const checkAscGoalDesc = (ascGoalDesc:string,errors:string[]) => {
    if (ascGoalDesc.trim().length < 10) {
        errors.push('Associate goal description must be atleast 10 characters');
    } else if (ascGoalDesc.trim().length > 200) {
        errors.push('Associate Goal description must be less than 200 characters');
    }
};
const decimalRegex=/^\d{0,7}(\.\d{0,4})?$/
export const checkTarget = (target:string,errors:string[]) => {
    if (target === '') {
        errors.push('Target/Result cannot be empty');
    } else {
        if (!decimalRegex.test(target)) {
            errors.push('Target/Result must be a number');
            return;
        }
        const numTarget=parseInt(target,10);
        if (numTarget < 0) {
            errors.push('Target/Result cannot be negative');
        }
        if (Math.floor(numTarget)!== numTarget && target.toString().split('.')[1].length > 4) {
            errors.push('Target/Result cannot have more than 4 decimal places');
        }
        if (numTarget > 9999999.9999) {
            errors.push('Target/Result is out of range');
        }
    }
};
export const checkPayout = (expectedPayout:string,errors:string[]) => {
    if (expectedPayout === '') {
        errors.push('Payout cannot be empty');
    } else {
        if (!decimalRegex.test(expectedPayout)) {
            errors.push('Payout must be a number');
            return;
        }
        const numPayout=parseInt(expectedPayout,10);
        if (numPayout < 0) {
            errors.push('Payout cannot be negative');
        }
        if (
            Math.floor(numPayout) !== numPayout &&
            expectedPayout.toString().split('.')[1].length > 4
        ) {
            errors.push('Payout cannot have more than 4 decimal places');
        }
        if (numPayout > 9999999.9999) {
            errors.push('Payout is out of range');
        }
    }
};

export const createGoalSettingPayload = (data: any,expectedPayout: any, target: any, ascGoalDesc: string, tlGoalDesc: string, locked: boolean, discussed: boolean, currEmpId: string) => {
    const payload: any = {};
    payload.goalId = data.coaching_goal_id;
    const currDate = new Date();

        let respFlag=false;
        let authorFlag=false;

        if (expectedPayout !== (data.setting.expected_payout || '')) {
            payload.expectedPayout = expectedPayout;
            respFlag=true;
        }
        if (target !== (data.target_goal_value || '')) {
            payload.targetGoalValue = parseFloat(target);
            respFlag=true;
        }
        if (ascGoalDesc !== (data.setting.response_description || '')) {
            payload.responseDescription = ascGoalDesc;
            respFlag=true;
        }
        if (tlGoalDesc !== (data.setting.goal_description || '')) {
            payload.goalDescription = tlGoalDesc;
            authorFlag=true;
        }
        if (locked !== data.goal_locked) {
            payload.isLocked = locked;
            respFlag=true;
        }
        if (discussed !== data.setting.goal_discussed) {
            payload.isDiscussed = discussed;
            authorFlag=true;
        }
        if(respFlag){
            payload.responseDate = `${currDate.getFullYear()}-${
                currDate.getMonth() + 1
            }-${currDate.getDate()}`;
            payload.responseEmployeeNumber = currEmpId;
        }
        if(authorFlag){
            payload.goalDate=`${currDate.getFullYear()}-${
                currDate.getMonth() + 1
            }-${currDate.getDate()}`;
            payload.authorEmployeeNumber=currEmpId;
        }
    return payload;
};

export const createGoalReviewPayload=(data:any,actualGoalValue:any,actualPayout:any,tlGoalDesc:string,ascGoalDesc:string,reviewed:boolean,currEmpId:string)=>{
    const payload:any={};
    payload.goalId=data.coaching_goal_id;
    const currDate=new Date();
    let respFlag=false;
    let authorFlag=false;
    if(actualGoalValue!==(data.actual_goal_value||'')){
        payload.actualGoalValue=actualGoalValue;
        authorFlag=true;
    }
    if(actualPayout!==(data.review?.actual_payout||'')){
        payload.actualPayout=parseFloat(actualPayout);
        authorFlag=true;
    }
    if(ascGoalDesc!==(data.review?.response_month_end_review_comment||'')){
        payload.responseMonthEndReviewComment=ascGoalDesc;
        respFlag=true;
    }
    if(tlGoalDesc!==(data.review?.author_month_end_review_comment||'')){
        payload.authorMonthEndReviewComment=tlGoalDesc;
        authorFlag=true;
    }
    if(reviewed!==data.reviewed){
        payload.isReviewed=reviewed;
        respFlag=true;
    }
    if(respFlag){
        payload.responseReviewDate=`${currDate.getFullYear()}-${
            currDate.getMonth()+1
        }-${currDate.getDate()}`;
        payload.responseEmployeeNumber=currEmpId;
    }
    if(authorFlag){
        payload.authorReviewDate=`${currDate.getFullYear()}-${
            currDate.getMonth()+1
        }-${currDate.getDate()}`;
        payload.authorEmployeeNumber=currEmpId;
    }
    return payload;
}